<template>
  <div class="landing-container">
    <div class="landing-feature-card">
      <h2 class="landing-text">While we are building our website</h2>
      <span class="landing-text1">You can book your next experience with us</span>
      <code id="form" class="landing-text2">info@madeiraroots.tours</code>
      <div id="contact-us-form" class="landing-container1"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Landing',
  metaInfo: {
    title: 'Madeira Roots',
    meta: [
      {
        name: 'description',
        content: 'Deep dive into Madeira Roots',
      },
      {
        property: 'og:title',
        content: 'Madeira Roots',
      },
      {
        property: 'og:description',
        content: 'Deep dive into Madeira Roots',
      },
    ],
  },
}
</script>

<style scoped>
.landing-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-gray-900);
}
.landing-feature-card {
  width: 100%;
  display: flex;
  padding: 32px;
  align-items: center;
  flex-direction: column;
  padding-bottom: 32px;
}
.landing-text {
  font-style: normal;
  margin-top: var(--dl-space-space-unit);
  text-align: center;
  font-weight: 500;
  margin-bottom: var(--dl-space-space-unit);
}
.landing-text1 {
  color: var(--dl-color-gray-700);
  text-align: center;
}
.landing-text2 {
  color: var(--dl-color-gray-700);
  text-align: center;
}
.landing-container1 {
  width: 666px;
  border: 2px dashed rgba(120, 120, 120, 0.4);
  height: 315px;
  display: flex;
  align-items: flex-start;
}
</style>
